$( document ).ready(function() {
if(window.location.href.indexOf('#') > -1){
var getTag= window.location.href.split('#')[1];
var flag=0;
$('.left_side_tabs h3').each(function(){
if($.trim($(this).attr('value'))==$.trim(getTag)){
flag=1;
}
});
if(flag==0){
if(getTag.indexOf('all_') >-1){
var parentTabname=getTag.split('_')[1];
  var childTab='all';
    
$('.main_video_section_wrapp a, .left_side_tabs h3').removeClass('is__active');
$('.main_video_section_wrapp a[data-value="'+childTab+'"]').addClass('is__active');
var mainTabHandle= parentTabname;
$('.left_side_tabs h3[value="'+mainTabHandle+'"]').addClass('is__active');
$('.main_video_section_wrapp').hide();
$('.bottom_tabs, .sub-tittle-tab').hide();
$('.bottom_tabs[data_handle_new="'+childTab+'"] , .sub-tittle-tab[subhead_handle="'+childTab+'"]').show();
$('.main_video_section_wrapp[data-heading="'+mainTabHandle+'"]').show();
$('.main_video_section_wrapp[data-heading="'+mainTabHandle+'"] .custom_video').show();
  
}else{
  
$('.main_video_section_wrapp a, .left_side_tabs h3').removeClass('is__active');
$('.main_video_section_wrapp a[data-value="'+getTag+'"]').addClass('is__active');
var mainTabHandle= $('.main_video_section_wrapp a[data-value="'+getTag+'"]').parents('.main_video_section_wrapp').attr('data-heading');
$('.left_side_tabs h3[value="'+mainTabHandle+'"]').addClass('is__active');
$('.main_video_section_wrapp').hide();
$('.bottom_tabs, .sub-tittle-tab').hide();
$('.bottom_tabs[data_handle_new="'+getTag+'"] , .sub-tittle-tab[subhead_handle="'+getTag+'"]').show();
$('.main_video_section_wrapp[data-heading="'+mainTabHandle+'"]').show();
$('.main_video_section_wrapp[data-heading="'+mainTabHandle+'"] .custom_video').hide();
$('.main_video_section_wrapp[data-heading="'+mainTabHandle+'"] .custom_video[data_handle_new="'+getTag+'"]').show();
}
}
}

});